export default "__VITE_ASSET__BX0mGib6__"